import React, { useState } from 'react'
import LayoutBasic from '../layouts/layoutBasic'
import Link from 'next/link'
import moment from 'moment'
import SearchBar, { SearchCompThin } from '../components/searchBar'
import { SeoMetaPricing } from '../components/seoMeta'
import Router from 'next/router'
import { TOKEN, GET_CUSTOMER_SUBSCRIPTION, GET_SUBSCRIPTIONS_DOWNLOADS, GET_USER_URL, CART } from '../vars'
import { withRouter } from 'next/router'
import { setLocalKeyValue, getLocalKeyValue, getJsonData, setJsonData } from '../storage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { Tabs, Tab } from 'react-bootstrap-tabs';
import { GET } from '../helpers';
import getPriceList from "../components/priceList";
import checkIsOutsideIndia from '../components/checkIsOutsideIndia'
import Axios from 'axios'

function Collapse(props) {
  let [isOpen, setOpen] = useState(false)

  let icon = <FontAwesomeIcon icon={faPlus} />
  if (isOpen) {
    icon = <FontAwesomeIcon icon={faMinus} />
  }
  return <div>
    <div onClick={() => { setOpen(!isOpen) }} className="faq">
      <div className="d-flex">
        <div className={isOpen ? "mb-2" : ''}>
          <span className={isOpen ? "txt-underline" : "text-decoration-none"} >{props.que}</span>
        </div>
        <div className="ms-auto">
          {icon}
        </div>
      </div>
    </div>
    <div className={isOpen ? "d-block" : "d-none"}>
      <p dangerouslySetInnerHTML={{ __html: props.ans }}></p>
    </div>
  </div>
}
class Pricing extends React.Component {

  constructor() {
    super();
    this.formatPrice = this.formatPrice.bind(this);
    this.state = {
      tabs: 0,
      value_tabs: 1,
      latitude: null,
      longitude: null,
      priceList: {},
      error: null,
      apiPrices: {},
      isOutsideIndia: false,
      selectedPlan: 'monthly',
      activeSection: 'valuePack',  // Default to 'valuePack'
      // value_tabs: 0,
      tabs: 1,
      valuePack_content: true,
      subscritption_content: false,
      hideRadio_button: true

    }
  }

  static async getInitialProps(props) {
    let token = await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

    let infoRequest, infoResponse = {}
    if (token) {
      try {
        infoRequest = await GET(GET_USER_URL, token)
        infoResponse = await infoRequest.data
      } catch (e) {

      }
    }

    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
    }
  }

  componentDidMount() {

    const { latitude, longitude } = this.props;
    const isOutsideIndia = checkIsOutsideIndia(latitude, longitude);
    this.setState({ isOutsideIndia, value_tabs: 2 })


    const apiPrices = {
      "Value Pack": {
        "3 Credits": { INR: 360, USD: 6 },
        "10 Credits": { INR: 1000, USD: 16.5 },
        "25 Credits": { INR: 2250, USD: 37.1 },
        "100 Credits": { INR: 8000, USD: 131.8 },
        "250 Credits": { INR: 15000, USD: 247 }
      },
      "Subscription Pack": {
        "Monthly": {
          "50 Credits": { INR: 4500, USD: 74.1 },
          "150 Credits": { INR: 12000, USD: 197.6 },
          "350 Credits": { INR: 17500, USD: 288.2 }
        },
        "Quarterly": {
          "50 Credits": { INR: 4250, USD: 70 },
          "150 Credits": { INR: 10500, USD: 172.9 },
          "350 Credits": { INR: 14000, USD: 230.5 }
        }
      }
    }




    this.setState({
      latitude: latitude,  // Latitude for San Francisco, US
      longitude: longitude, // Longitude for San Francisco, US
      error: null,
      apiPrices: apiPrices


    }, this.updatePriceList);
  }

  updatePriceList = () => {
    const { latitude, longitude, apiPrices } = this.state;
    const priceList = getPriceList(latitude, longitude, apiPrices);
    this.setState({ priceList: priceList });
  }

  // Method to handle radio button change
  handlePlanChange = (e) => {


    this.setState({ selectedPlan: e.target.value, activeSection: 'subscription' }, () => {
      if (this.state.activeSection === 'valuePack') {
        this.setState({ valuePack_content: true, subscritption_content: false })
      } else if (this.state.activeSection === 'subscription') {
        this.setState({ valuePack_content: false, subscritption_content: true })
      }
    }); // Update state based on selected plan
    // Perform actions based on active tab

  };



  handleTabSelect = (section, index) => {
    this.setState({ activeSection: section, value_tabs: index }, () => {
      if (this.state.activeSection === 'valuePack') {
        this.setState({ valuePack_content: true, subscritption_content: false })
      } else if (this.state.activeSection === 'subscription') {
        this.setState({ valuePack_content: false, subscritption_content: true })
      }
    });
  };

  handleTabSelectSubscription = (section, index) => {
    index === 3 ? this.setState({ hideRadio_button: false }) : this.setState({ hideRadio_button: true });
    this.setState({ activeSection: section, tabs: index }, () => {
      if (this.state.activeSection === 'valuePack') {
        this.setState({ valuePack_content: true, subscritption_content: false })
      } else if (this.state.activeSection === 'subscription') {
        this.setState({ valuePack_content: false, subscritption_content: true })
      }
    });
  };


  formatPrice(price) {
    // Check if price exists
    if (!price) {
      return null;
    }

    // Remove the currency symbol (₹ or $)
    const numericPrice = price.replace(/[₹$]/, '');

    // Split into whole and decimal parts
    const [whole, decimal] = numericPrice.split('.');

    // Determine the currency symbol (₹ or $)
    const currencySymbol = price.includes('₹') ? '₹' : '$';

    // If the price is in rupees, return without decimals
    if (currencySymbol === '₹') {
      return (
        <>
          {currencySymbol}{whole}
        </>
      );
    }

    // Ensure the decimal part has two digits for dollars
    const formattedDecimal = (decimal || '0').padEnd(2, '0');

    // Return with superscript decimal for dollars
    return (
      <>
        {currencySymbol}{whole}
        <sup>{formattedDecimal}</sup>
      </>
    );
  }


  render() {

    const { priceList, isOutsideIndia, selectedPlan, activeSection, valuePack_content, subscritption_content, hideRadio_button } = this.state;


    let active_label = <>
      <div>
        <small className="bg-success text-white rounded p-1">Best seller</small>
      </div>
      <span>150</span>
    </>
    let value_active_label = <>
      <div>
        <small className="bg-success text-white rounded p-1">Best seller</small>
      </div>
      <span>25</span>
    </>

    let radioButton = hideRadio_button && (<>
      {/* Radio buttons for plan selection */}
      <div className="plan-selection">
        <label>
          <input
            type="radio"
            value="monthly"
            checked={selectedPlan === 'monthly'}
            onChange={this.handlePlanChange}
          /> Monthly
        </label>
        <label>
          <input
            type="radio"
            value="quarterly"
            checked={selectedPlan === 'quarterly'}
            onChange={this.handlePlanChange}
          /> Quarterly
        </label>
      </div>
    </>)
    // active_label = "&lt;div  className='text-center best-seller' &gt;Best seller &lt;div&gt;100 Credits"
    return <section style={{ backgroundImage: "url('../static/img/pricing-main-bg.png')" }}><LayoutBasic title="Stock Photos, Royalty-free License Prices & Plans" {...this.props} navSearchBtn={'no'} defaultNavBar={true}>
      <SeoMetaPricing {...this.props} />
      <div className="container my-sm-3 py-sm-2 my-md-3 py-md-2 pricing">
        <div className="text-center mb-3">
          <h1 className="display-1 white">
            Tailor-made plans for your needs
          </h1>
          <h3 className="display-1 white">Explore 100M+ premium photos</h3>
        </div>
      </div>
      <div className="mb-5">
        <div className="container text-center">
          <div className="row justify-content-center pricing-tabs">
            <div className="col-md-6 price-data">
              {valuePack_content && (<div className='price-data-content'>
                <h3>Value Packs</h3>
                <ul>
                  <li>100M+ Premium photos</li>
                  <li>Genuine visuals reflecting local and regional culture</li>
                  <li>1 Credit is 1 Digital image & 10 Credits is 1 Print image</li>
                  <li>Premium features, affordable pricing</li>
                  <li>No attribution required</li>
                  <li>Legal protection, so you can use images worry-free</li>
                  {/* <li>Daily downloads More info</li> */}
                </ul>
                <ul className='icons-block'>
                  <li><img src="/static/img/royalty-free.svg" /> <span>Royalty-Free<br />License</span></li>
                  <li><img src="/static/img/safe-icon.svg" /> <span>100% Safe<br />& Trust</span></li>
                  <li><img src="/static/img/ad-free-icon.svg" /> <span>Ad-free<br />Browsing</span></li>
                  <li><img src="/static/img/support-icon.svg" /> <span>On Call<br />Support</span></li>
                  <li><img src="/static/img/email-support.svg" /> <span>Email<br /> Support</span></li>
                </ul>
              </div>)}
              {subscritption_content && (<div className='price-data-content'>
                <h3>Subscription Plans</h3>
                <ul>
                  <li>Save additional 15% than value pack discounts</li>
                  <li>100M+ Premium photos</li>
                  <li>1 Credit is 1 Digital image & 10 Credits is 1 Print image</li>
                  <li>Genuine visuals reflecting local and regional culture</li>
                  <li>Credits auto-refill every month/3months</li>
                  <li>Unused credits carry forward during auto-renewal</li>
                  {/* <li>No attribution required</li> */}
                </ul>
                <ul className='icons-block'>
                  <li><img src="/static/img/royalty-free.svg" /> <span>Royalty-Free<br />License</span></li>
                  <li><img src="/static/img/safe-icon.svg" /> <span>100% Safe<br />& Trust</span></li>
                  <li><img src="/static/img/ad-free-icon.svg" /> <span>Ad-free<br />Browsing</span></li>
                  <li><img src="/static/img/support-icon.svg" /> <span>Call<br />Support</span></li>
                  <li><img src="/static/img/email-support.svg" /> <span>Email<br /> Support</span></li>
                </ul>
              </div>)}
            </div>
            <div className={`col-md-3 mb-3 card-block ${activeSection === 'valuePack' ? 'zoom-active' : ''}`}>
              {/* <div className="col-md-3 mb-3 zoom-active"> */}
              <div className="card p-0 pricing-card pricing-value-packs active">
                <h1 className="mb-3">Value Packs</h1>
                <h4>Select Download Credits</h4>
                <div className="plan-selection"><label>One Time Pay</label></div>
                <Tabs onSelect={(index) => {
                  this.handleTabSelect('valuePack', index);
                  this.setState({ value_tabs: index });
                }} selected={this.state.value_tabs}>
                  <Tab label={<span>3</span>}>
                    <div className="mt-4">
                      <div className="mb-4 p-3 mt-5 pt-5">
                        {/* <div className="plan-text mb-3">One time pay, no commitment needed</div> */}
                        <div className="price-block">
                          {/* <span className="plan-price">&#8377; 360</span> */}
                          <span className="plan-price">{this.formatPrice(priceList["Value Pack - 3 Credits"]?.price)}</span>
                        </div>
                        {!isOutsideIndia ? (<>
                          <div className="per-img-text">&#8377; 120 per credit</div>
                          <div className="text-success">save 40%</div>
                        </>) : (<>
                          <div className="text-success">save 40%</div>
                          <div className="per-img-text">&nbsp;</div>
                        </>)}
                      </div>

                      <Link href={isOutsideIndia ? "/valuePack_payment?plan_name=value_pack_usd_3" : "/valuePack_payment?plan_name=value-3"}>
                        <a className="btn btn-primary mb-3" >Buy Now</a></Link>
                    </div>
                  </Tab>
                  {/* <Tab label={value_active_label}> */}
                  <Tab label={<span>10</span>}>
                    <div className="mt-4">
                      <div className="mb-4 p-3 mt-5 pt-5">
                        {/* <div className="plan-text mb-3">One time pay, no commitment needed</div> */}
                        <div className="price-block">
                          {/* <span className="plan-price">&#8377; 1,000</span> */}
                          {/* <span className="plan-price">{priceList["Value Pack - 10 Credits"]?.price}</span> */}
                          <span className="plan-price">{this.formatPrice(priceList["Value Pack - 10 Credits"]?.price)}</span>
                        </div>
                        {!isOutsideIndia ? (<>
                          <div className="per-img-text">&#8377; 100 per credit</div>
                          <div className="text-success">save 50%</div>
                        </>) : (<>
                          <div className="text-success">save 50%</div>
                          <div className="per-img-text">&nbsp;</div>
                        </>)}
                      </div>
                      <Link href={isOutsideIndia ? "/valuePack_payment?plan_name=value_pack_usd_10" : "/valuePack_payment?plan_name=value-10"}>


                        {/* <Link href="/valuePack_payment?plan_name=value-10"> */}
                        <a className="btn btn-primary mb-3" >Buy Now</a>
                      </Link>
                    </div>
                  </Tab>
                  {/* <Tab label={<span>25</span>}> */}
                  <Tab label={value_active_label}>
                    <div className="mt-4">
                      <div className="mb-4 p-3 mt-5 pt-5">
                        {/* <div className="plan-text mb-3">One time pay, no commitment needed</div> */}
                        <div className="price-block">
                          {/* <span className="plan-price">&#8377; 2,250</span> */}
                          <span className="plan-price">{this.formatPrice(priceList["Value Pack - 25 Credits"]?.price)}</span>
                        </div>
                        {!isOutsideIndia ? (<>
                          <div className="per-img-text">&#8377; 90 per credit</div>
                          <div className="text-success">save 55%</div>
                        </>) : (<>
                          <div className="text-success">save 55%</div>
                          <div className="per-img-text">&nbsp;</div>
                        </>)}
                      </div>
                      <Link href={isOutsideIndia ? "/valuePack_payment?plan_name=value_pack_usd_25" : "/valuePack_payment?plan_name=value-25"}>
                        {/* <Link href="/valuePack_payment?plan_name=value-25"> */}
                        <a className="btn btn-primary mb-3" >Buy Now</a>
                      </Link>
                    </div>
                  </Tab>
                  <Tab label={<span>100</span>}>
                    <div className="mt-4">
                      <div className="mb-4 p-3 mt-5 pt-5">
                        {/* <div className="plan-text mb-3">One time pay, no commitment needed</div> */}
                        <div className="price-block">
                          {/* <span className="plan-price">&#8377; 8,000</span> */}
                          <span className="plan-price">{this.formatPrice(priceList["Value Pack - 100 Credits"]?.price)}</span>
                        </div>
                        {!isOutsideIndia ? (<>
                          <div className="per-img-text">&#8377; 80 per credit</div>
                          <div className="text-success">save 60%</div>
                        </>) : (<>

                          <div className="text-success">save 60%</div>
                          <div className="per-img-text">&nbsp;</div>
                        </>)}
                      </div>
                      <Link href={isOutsideIndia ? "/valuePack_payment?plan_name=value_pack_usd_100" : "/valuePack_payment?plan_name=value-100"}>
                        {/* <Link href="/valuePack_payment?plan_name=value-100"> */}
                        <a className="btn btn-primary mb-3" >Buy Now</a>
                      </Link>
                    </div>
                  </Tab>
                  <Tab label={<span>250</span>}>
                    <div className="mt-4">
                      <div className="mb-4 p-3 mt-5 pt-5">
                        {/* <div className="plan-text mb-3">One time pay, no commitment needed</div> */}
                        <div className="price-block">
                          {/* <span className="plan-price">&#8377; 15,000</span> */}
                          <span className="plan-price">{this.formatPrice(priceList["Value Pack - 250 Credits"]?.price)}</span>
                        </div>
                        {!isOutsideIndia ? (<>
                          <div className="per-img-text">&#8377; 60 per credit</div>
                          <div className="text-success">save 70%</div>
                        </>) : (<>
                          <div className="text-success">save 70%</div>
                          <div className="per-img-text">&nbsp;</div>
                        </>)}
                      </div>
                      <Link href={isOutsideIndia ? "/valuePack_payment?plan_name=value_pack_usd_250" : "/valuePack_payment?plan_name=value-250"}>
                        {/* <Link href="/valuePack_payment?plan_name=value-250"> */}
                        <a className="btn btn-primary mb-3" >Buy Now</a>
                      </Link>
                    </div>
                  </Tab>
                </Tabs>
              </div>
              {/* <div className="text-left col-mb-12"><b>Credit Guide - " 1 Digital Photo = 1 Credit & 1 Print Photo = 10 Credits" </b></div> */}
            </div>
            <div className={`col-md-3 card-block ${activeSection === 'subscription' ? 'zoom-active' : ''}`}>
              <div className="card p-0 pricing-card pricing-value-packs">
                <h1 className="mb-3">Subscription Plans</h1>
                <h4>Select Download Credits</h4>
                {radioButton}

                {/* <Tabs onSelect={(index, lable) => this.setState({ tabs: index })} selected={this.state.tabs}> */}
                <Tabs
                  onSelect={(index) => {
                    this.handleTabSelectSubscription('subscription', index);
                    this.setState({ tabs: index });
                  }}
                  selected={this.state.tabs}
                >
                  <Tab label={<span>50</span>}>
                    <div className="mt-4">
                      <div className="row m-0">
                        {selectedPlan === 'monthly' && (<div className="col-sm p-0 custome-border">
                          <div className="mb-4 p-3 mt-4 pt-5">
                            {/* <div className="plan-text mb-3">Monthly Plan</div> */}
                            <div className="price-block">
                              {/* <span className="plan-price">&#8377; 4,500</span> */}
                              <span className="plan-price">{this.formatPrice(priceList["Subscription Pack - Monthly - 50 Credits"]?.price)}</span>
                              <span>/month</span>
                            </div>
                            {!isOutsideIndia ? (<>
                              <div className="per-img-text">&#8377; 90 per credit</div>
                              <div className="text-success">save 55%</div>
                            </>) : (<>
                              <div className="text-success">save 55%</div>
                              <div className="per-img-text">&nbsp;</div>
                            </>)}
                          </div>
                          <Link href={isOutsideIndia ? "/checkout_subscription?plan_name=subscription-m-usd-c50" : "/checkout_subscription?plan_name=subscription-4500"}>

                            {/* <Link href="/checkout_subscription?plan_name=subscription-4500"> */}
                            <a className="btn btn-primary mb-3" >Buy Now</a>
                          </Link>
                        </div>)}
                        {selectedPlan === 'quarterly' && (<div className="col-sm p-0">
                          <div className="mb-4 p-3 mt-4 pt-5">
                            {/* <div className="plan-text mb-3">Quarterly Plan</div> */}
                            <div className="price-block">
                              {/* <span className="plan-price">&#8377; 4,250</span> */}
                              <span className="plan-price">{this.formatPrice(priceList["Subscription Pack - Quarterly - 50 Credits"]?.price)}</span>
                              <span>/month</span>
                            </div>
                            {!isOutsideIndia ? (<>
                              <div className="per-img-text">&#8377; 85 per credit</div>
                              <div className="text-success">save 57.5%</div>
                            </>) : (<>
                              <div className="text-success">save 57.5%</div>
                              <div className="per-img-text">&nbsp;</div>
                            </>)}
                          </div>
                          <Link href={isOutsideIndia ? "/checkout_subscription?plan_name=subscription-q-usd-c50" : "/checkout_subscription?plan_name=quarterly-12750"}>
                            {/* <Link href="/checkout_subscription?plan_name=quarterly-12750"> */}
                            <a className="btn btn-primary mb-3" >Buy Now</a>
                          </Link>
                        </div>)}
                      </div>
                    </div>
                  </Tab>
                  <Tab label={active_label}>
                    <div className="mt-4 position-relative">
                      <div className="row m-0">
                        {selectedPlan === 'monthly' && (<div className="col-sm p-0 custome-border">
                          <div className="mb-4 p-3 mt-4 pt-5">
                            {/* <div className="plan-text mb-3">Monthly Plan</div> */}
                            <div className="price-block">
                              {/* <span className="plan-price">&#8377; 12,000</span> */}
                              <span className="plan-price">{this.formatPrice(priceList["Subscription Pack - Monthly - 150 Credits"]?.price)}</span>
                              <span>/month</span>
                            </div>
                            {!isOutsideIndia ? (<>
                              <div className="per-img-text">&#8377; 80 per credit</div>
                              <div className="text-success">save 60%</div>
                            </>) : (<>
                              <div className="text-success">save 60%</div>
                              <div className="per-img-text">&nbsp;</div>
                            </>)}
                          </div>
                          <Link href={isOutsideIndia ? "/checkout_subscription?plan_name=subscription-m-usd-c100" : "/checkout_subscription?plan_name=subscription-12000"}>
                            {/* <Link href="/checkout_subscription?plan_name=subscription-12000"> */}
                            <a className="btn btn-primary mb-3" >Buy Now</a>
                          </Link>
                        </div>)}
                        {selectedPlan === 'quarterly' && (<div className="col-sm p-0">
                          <div className="mb-4 p-3 mt-4 pt-5">
                            {/* <div className="plan-text mb-3">Quarterly Plan</div> */}
                            <div className="price-block">
                              {/* <span className="plan-price">&#8377; 10,500</span> */}
                              <span className="plan-price">{this.formatPrice(priceList["Subscription Pack - Quarterly - 150 Credits"]?.price)}</span>
                              <span>/month</span>
                            </div>
                            {!isOutsideIndia ? (<>
                              <div className="per-img-text">&#8377; 70 per credit</div>
                              <div className="text-success">save 65%</div>
                            </>) : (<>
                              <div className="text-success">save 65%</div>
                              <div className="per-img-text">&nbsp;</div>
                            </>)}
                          </div>
                          <Link href={isOutsideIndia ? "/checkout_subscription?plan_name=subscription-q-usd-c100" : "/checkout_subscription?plan_name=quarterly-31500"}>

                            {/* <Link href="/checkout_subscription?plan_name=quarterly-31500"> */}
                            <a className="btn btn-primary mb-3" >Buy Now</a>
                          </Link>
                        </div>)}
                      </div>
                    </div>
                  </Tab>
                  <Tab label={<span>350</span>}>
                    <div className="mt-4">
                      <div className="row m-0">
                        {selectedPlan === 'monthly' && (<div className="col-sm p-0 custome-border">
                          <div className="mb-4 p-3 mt-4 pt-5">
                            {/* <div className="plan-text mb-3">Monthly Plan</div> */}
                            <div className="price-block">
                              {/* <span className="plan-price">&#8377; 17,500</span> */}
                              <span className="plan-price">{this.formatPrice(priceList["Subscription Pack - Monthly - 350 Credits"]?.price)}</span>
                              <span>/month</span>
                            </div>
                            {!isOutsideIndia ? (<>
                              <div className="per-img-text">&#8377; 50 per credit</div>
                              <div className="text-success">save 75%</div>
                            </>) : (<>

                              <div className="text-success">save 75%</div>
                              <div className="per-img-text">&nbsp;</div>
                            </>)}
                          </div>
                          <Link href={isOutsideIndia ? "/checkout_subscription?plan_name=subscription-m-usd-c350" : "/checkout_subscription?plan_name=subscription-17500"}>

                            {/* <Link href="/checkout_subscription?plan_name=subscription-17500"> */}
                            <a className="btn btn-primary mb-3" >Buy Now</a>
                          </Link>
                        </div>)}
                        {selectedPlan === 'quarterly' && (<div className="col-sm p-0">
                          <div className="mb-4 p-3 mt-4 pt-5">
                            {/* <div className="plan-text mb-3">Quarterly Plan</div> */}
                            <div className="price-block">
                              {/* <span className="plan-price">&#8377; 14,000</span> */}
                              <span className="plan-price">{this.formatPrice(priceList["Subscription Pack - Quarterly - 350 Credits"]?.price)}</span>
                              <span>/month</span>
                            </div>
                            {!isOutsideIndia ? (<>
                              <div className="per-img-text">&#8377; 40 per credit</div>
                              <div className="text-success">save 80%</div>
                            </>) : <>
                              <div className="text-success">save 80%</div>
                              <div className="per-img-text">&nbsp;</div>
                            </>}
                          </div>
                          <Link href={isOutsideIndia ? "/checkout_subscription?plan_name=subscription-q-usd-c350" : "/checkout_subscription?plan_name=quarterly-42000"}>

                            {/* <Link href="/checkout_subscription?plan_name=quarterly-42000"> */}
                            <a className="btn btn-primary mb-3" >Buy Now</a>
                          </Link>
                        </div>)}
                      </div>
                    </div>
                  </Tab>
                  <Tab label={<span>Custom</span>}>
                    <div className="text-center my-3">
                      <div className="plan-price custom-text p-5">Looking for a more personalized plan?</div>
                    </div>
                    <div className="mb-3">

                      <Link href="https://api.whatsapp.com/send?phone=8885558235">
                        <a className="btn btn-primary ms-2" target="_blank">Contact Us</a>
                      </Link>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*<div className="bg-light pt-4 pb-5">
           <div className="container">
            <h1 className="display-1 mb-3 text-center" >Credit Guide</h1>

            <div className="row justify-content-center my-2">
              <div className="col-md-5 ">

                <div className="">

                <table className="table table-bordered" >
                  <thead>
                    <tr>
                      <th className="text-center text-muted h1">
                        Photos
                      </th>
                      <th className="text-center text-muted h1">
                        Videos
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-weight-bold">
                    <tr>
                      <td  className="text-center">
                        <div className="mb-2 ">1 Digital Photo = 1 Credit</div>
                        <div className="mb-2">1 Print Photo = 10 Credits</div>
                      </td>
                      <td>
                        <div className="mb-2">1 SD Video = 5 Credits</div>
                        <div className="mb-2">1 HD Video = 10 Credits</div>
                        <div className="mb-2">1 4K Video = 15 Credits</div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                </div>



              </div>
            </div>
          </div>
        </div>*/}
      <div className="bg-picxy-blue py-4 text-center">
        <span className="f-24 me-4 text-white">Looking for a more personalized plan?</span>
        <Link href="/contact_us">
          <a className="btn btn-warning ms-2">Contact Us</a>
        </Link>
      </div>
      <div className="bg-light py-5">
        <div className="container text-center">
          <h1 className="display-1 mb-5">Why Picxy?</h1>
          <div className="row">
            <div className="col-md-4 col-6 mb-5">
              <img src="/static/img/pricing/image.svg" className="img-fluid" />
              <div className="px-md-5 py-3 text-dark">
                Access to daily, exclusive visual content
              </div>
            </div>
            <div className="col-md-4 col-6 mb-5">
              <img src="/static/img/pricing/users.svg" className="img-fluid" />
              <div className="px-md-5 py-3 text-dark">
                Multiple user logins with annual subscriptions
              </div>
            </div>
            <div className="col-md-4 col-6 mb-5 mb-sm-0">
              <img src="/static/img/pricing/download-cloud.svg" className="img-fluid" />
              <div className="px-md-5 py-3 text-dark">
                Now re-download visuals with no extra cost
              </div>
            </div>
            <div className="col-md-4 col-6 mb-5 mb-sm-0">
              <img src="/static/img/pricing/copy.svg" className="img-fluid" />
              <div className="px-md-5 py-3 text-dark">
                No limit to digital usage of downloads
              </div>
            </div>
            <div className="col-md-4 col-6">
              <img src="/static/img/pricing/globe.svg" className="img-fluid" />
              <div className="px-md-5 py-3 text-dark">
                Worldwide availability and usage
              </div>
            </div>
            <div className="col-md-4 col-6">
              <img src="/static/img/pricing/calendar.svg" className="img-fluid" />
              <div className="px-md-5 py-3 text-dark">
                No daily limit for downloads
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className='bg-white py-5'>
        <div className="container my-5 pricing" id="faqs">
          <h2 className="display-1 mb-5 text-center">Frequently asked questions</h2>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <ul className="list-group">
                <li className="list-group-item">
                  <Collapse que="How are credits debited?" ans="If image is downloaded under digital usage, it is 1 credit. If it is downloaded under print usage it is 10 credits." />
                </li>
                <li className="list-group-item">
                  <Collapse que="Are the remaining credits carried to next month?" ans="Remaning credits will be carried to next month, as long as the subscription is active." />
                </li>
                <li className="list-group-item">
                  <Collapse que="What is value pack?" ans="Download images anytime within 3 months of purchase for 3 and 10 Credits Value Packs. For remaining packs, download anytime within 6 months of purchase." />
                </li>
                <li className="list-group-item">
                  <Collapse que="What is quarterly plan?" ans="A quarterly plan is a 3 months recurring subsciption that enables you to save cost." />
                </li>
                <li className="list-group-item">
                  <Collapse que="Can I subscribe to multiple plans?" ans="No, at present we are allowing only one active plan at a time." />
                </li>
                <li className="list-group-item">
                  <Collapse que="How can I upgrade to new plan?" ans="<span>Please reach  to us to upgrade your plan. </span><a class='btn btn-primary' href='/contact_us'>Contact Us</a>" />
                </li>
                <li className="list-group-item">
                  <Collapse que="Can I cancel the plan when not needed?" ans="You can cancel the plan anytime. Your recurring payments will be stopped." />
                </li>
                <li className="list-group-item">
                  <Collapse que="Will I get refunded if I cancel the subscription?" ans="No refunds will be issued on the current subscription. The future recurring payments will be cancelled." />
                </li>
                <li className="list-group-item">
                  <Collapse que="What happens to my credits if I cancel?" ans="You are good to use those credits until the end of the validty of current subscription." />
                </li>
              </ul>
              <div className="text-center mt-5 f-18">Have more queries ? <Link href="/contact_us"><a className="btn btn-primary">Contact Us</a></Link></div>
            </div>
          </div>
        </div>
      </section>
    </LayoutBasic>
    </section>

  }
}





export default withRouter(Pricing)